import { AccountModel } from 'data-ng-authentication';
import { CustomContentsServant } from 'data-ng-custom-text';
import * as _4 from 'lodash4';
import { PriorityFeedCapabilityConfiguration } from '../../configuration';
import { STCConfigsModel } from '../../models/stcconfigs_model';
import { ICommand } from 'core-ts-types';
import { OpenableElementsQuery } from '../../queries/openable_elements_query';

export class AppSupportController {
  private advising: any;
  private technical: any;
  private defaultContactLabel: string = 'Schedule an Appointment';
  private contactButtonLabel: string;
  private selfAlert: any;
  constructor(
    private ngPriorityFeedCapabilityConfiguration: PriorityFeedCapabilityConfiguration,
    private $location: ng.ILocationService,
    private $state: ng.ui.IStateService,
    private appConfigModel: any,
    private accountModel: AccountModel,
    private ngCustomContentsServant: CustomContentsServant,
    private ngOpenableElementsQuery: OpenableElementsQuery,
    private openOpenableElementCommand: ICommand,
    private closeOpenableElementCommand: ICommand,
    private ngSTCConfigsModel: STCConfigsModel,
    private $scope: ng.IScope
  ) {}

  $onInit() {
    this.advising = this.appConfigModel.model.ADVISING_HELP;
    this.technical = this.appConfigModel.model.TECHNICAL_HELP;
    this.selfAlert = this.appConfigModel.model.SELF_ALERT_HELP;
    if (!this.isStudentPreview) {
      this.ngCustomContentsServant.getButtonLabel(this.defaultContactLabel).then((label: string) => {
        this.contactButtonLabel = label;
        //this forces angular to check the diff on updated elements
        this.$scope.$apply();
      });
    } else {
      this.contactButtonLabel = this.defaultContactLabel;
    }
  }

  get isStudentPreview() {
    const FAKE_STUDENT_PREFIX = `FAKE`;
    return _4.isEqual(_4.first(_4.split(this.accountModel.student_nk, '_')), FAKE_STUDENT_PREFIX);
  }

  gotoAppointmentScheduling(): void {
    window.location.assign('#/my/host/as3/appointment-new');
    this.closeAppSupport();
  }

  hasAppointmentScheduling(): boolean {
    return this.ngPriorityFeedCapabilityConfiguration.config.isAppointmentEnabled;
  }

  hasSelfAlert(): boolean {
    return this.ngPriorityFeedCapabilityConfiguration.config.isSelfAlertEnabled;
  }

  openSelfAlert() {
    return this.openOpenableElementCommand('selfAlertDialog');
  }

  getSelfAlertLabel() {
    return this.ngSTCConfigsModel.read().self_alert_label;
  }

  closeAppSupport() {
    return this.closeOpenableElementCommand('appSupportDrawer');
  }
}
export class AppSupportComponent implements ng.IComponentOptions {
  public controller: object = AppSupportController;
  public templateUrl: string = 'capability-ng-priority-feed/src/components/app_support/app_support.html';
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/components/app_support/app_support.ts